import { useEffect, useState } from 'react';
import {
  IEvaluationConditionFilters,
  IField,
  IFlow,
} from '../Components/Calculations/Conditions/Evaluation/EvaluationInterface';
import { ICalculationStep } from '../redux/Calculations/CurrentCalculationSessionInterface';
import { fetchUniqueOptions } from '../api/filters';
export interface IPayloadforFlows {
  calculatedFieldName: string;
  fields: IField;
  flows: {
    [key: string]: ICalculationStep[];
  };
  conditionFilters: IEvaluationConditionFilters;
}
export const usePickListOptions = (
  connectionId: string,
  dsId: string,
  workspaceId: string,
  calculationDetails: IFlow | null,
  timeGrain?: string,
  tableId?: string,
  fieldName?: string,
  dataType?: string,
  isFlow = false,
) => {
  const [data, setData] = useState<(string | number | null)[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ message: string; code: number; isError: boolean } | null>(
    null,
  );
  useEffect(() => {
    if ((!connectionId && !dsId) || !workspaceId) {
      setError({ message: 'Content not found', code: 400, isError: true });
      setLoading(false);
      return;
    }
    async function fetchData() {
      if (!tableId || !fieldName || !dataType) {
        setError({ message: 'Column details are not found', code: 400, isError: true });
        setLoading(false);
        return;
      } else if (isFlow && !calculationDetails) {
        setError({ message: 'Flow details are not found', code: 400, isError: true });
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const payload = {
          tableId: tableId,
          fieldName: fieldName,
          dataType: dataType,
          filterOption: 'allValues',
          timeGrain: timeGrain ?? 'year',
          ...(isFlow
            ? {
                isCalculatedField: true,
                calculatedField: [
                  {
                    calculatedFieldName: calculationDetails!.calculatedFieldName,
                    fields: calculationDetails!.fields,
                    flows: calculationDetails!.flows,
                    conditionFilters: calculationDetails!.conditionFilters,
                  },
                ],
              }
            : {}),
        };
        const _res = await fetchUniqueOptions(connectionId, dsId, workspaceId, payload);
        if (_res.isError) {
          setError({ message: _res.message, code: _res.responseStatusCode ?? 500, isError: true });
          setLoading(false);
          return;
        }
        setData(_res.data!);
        setLoading(false);
        setError(null);
      } catch (error) {
        setError({
          message: (error as any).message ?? 'Error while fetching the data',
          code: (error as any).code || 500,
          isError: true,
        });
        setLoading(false);
      }
    }
    fetchData();
  }, [
    timeGrain,
    isFlow,
    tableId,
    fieldName,
    dataType,
    connectionId,
    dsId,
    workspaceId,
    calculationDetails,
  ]);
  return { result: data, loading, error };
};
